import { apiConstants } from '../config';
let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    view: 'TP_00001',
                },
                url: {
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'backoffice.titles',
                label: 'backoffice.label',
                panel: {
                    show: false,
                },
                acl: {
                    view: 'TP_00053',
                },
                url: {
                    view: `:moduleCodegestao.home`,
                }
            },
            layers: {
                active: true,
                title: 'layers.title',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'TP_00051',
                },
                url: {
                    getLayers: `${codeAPI}/front/map/layers`,
                },
                selected: null,
            },
            dashboard: {
                active: true,
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'TP_00054',
                },
            },
            regulations: {
                active: true,
                title: 'regulations.titles',
                label: 'regulations.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'TP_00060',
                },
                url: {
                    getData: `${codeAPI}/front/regulations`,
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
                acl: {
                    view: null,
                },
            },
            catalog: {
                acl: {
                    view: 'TP_00058',
                },
            },
            identify: {
                acl: {
                    view: 'TP_00059',
                },
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: 'TP_00057',
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/front/print/visible`,
                    getStatusPrint: `${codeAPI}/front/print/visible/job/:id`,
                }
            },
            street_search: {
                active: true,
                title: 'street_search.titles',
                label: 'street_search.label',
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    geomProperty: 'geojson',
                    formatExportData: 'xls',
                },
                acl: {
                    view: 'TP_00061',
                    export: 'TP_00066',
                },
                url: {
                    searchAll: `${codeAPI}/streets/search`,
                    getAuxiliaries: `${codeAPI}/streets/search/lists`,
                    searchStreet: `${codeAPI}/streets/search/street`,
                    export: `${codeAPI}/streets/search/export`,
                    job: `${codeAPI}/streets/search/export/job/:id`,
                },
            },
            street: {
                active: true,
                title: 'street.title',
                panel: {
                    show: false,
                    loaded: false,
                    geomProperty: 'geojson',
                    featuresProperty: 'geojson',
                },
                acl: {
                    view: 'TP_00062',
                    add: 'TP_00063',
                },
                url: {
                    show: `${codeAPI}/streets/:id`,
                    create: `${codeAPI}/streets`,
                    update: `${codeAPI}/streets/:id`,
                    delete: `${codeAPI}/streets/:id`,
                    export: `${codeAPI}/streets/export/:id`,
                    getLists: `${codeAPI}/streets/lists`,
                    getRoadAxle: `${codeAPI}/streets/roadaxle`,
                },
            },
            house_number_search: {
                active: true,
                title: 'house_number_search.titles',
                label: 'house_number_search.label',
                panel: {
                    show: false,
                    loaded: false,
                    reload: false,
                    geomProperty: 'geojson',
                    includeAllOnZoomToStreet: true,
                    includeAllOnZoomToHouseNumber: true,
                    allowExportData: true,
                    formatExportData: 'xls',
                },
                acl: {
                    view: 'TP_00073',
                    export: 'TP_00071',
                },
                url: {
                    searchAll: `${codeAPI}/housenumbers/search`,
                    getAuxiliaries: `${codeAPI}/housenumbers/search/lists`,
                    searchStreet: `${codeAPI}/housenumbers/search/street`,
                    export: `${codeAPI}/housenumbers/search/export`,
                    job: `${codeAPI}/housenumbers/search/export/job/:id`,
                },
            },
            house_number: {
                active: true,
                title: 'house_number.title',
                panel: {
                    show: false,
                    loaded: false,
                    geomProperty: 'geojson',
                    featuresProperty: 'street.house_numbers',
                },
                acl: {
                    view: 'TP_00067',
                    add: 'TP_00068',
                    export: 'TP_00072',
                },
                url: {
                    show: `${codeAPI}/housenumbers/:id`,
                    showNumber: `${codeAPI}/housenumbers/number/:number`,
                    create: `${codeAPI}/housenumbers`,
                    update: `${codeAPI}/housenumbers/:id`,
                    delete: `${codeAPI}/housenumbers/:id`,
                    export: `${codeAPI}/housenumbers/export/:id`,
                    getLists: `${codeAPI}/housenumbers/lists`,
                    getStreetNumbers: `${codeAPI}/housenumbers/street/:id`,
                },
            },
        },
        map: {
            loading: false,
            action: null,
            config: {
                layers: {
                    street: {
                        layer: 'lyr_street',
                        source: 'vs_street',
                        zindex: 1000,
                        duration: 1500,
                        zoomScale: 1.25,
                    },
                    house_number: {
                        layer: 'lyr_housenumber',
                        source: 'vs_housenumber',
                        zindex: 1000,
                        duration: 1500,
                        zoomScale: 1.25,
                    },
                },
                interactions: {
                    spiderfier: null,
                },
                style: {
                    highlight: {
                        image: {
                            src: require(`../../images/marker-location-red.png`),
                        },
                    },
                    house_number: {
                        iconColorDefault: '#008FB6',
                        iconColorSelected: '#AA0114', //'#C21807'
                        iconOpacity: 0.8,
                        textProperty: 'number',
                        textFont: '.5rem sans-serif',
                        textColor: '#ffffff',
                        fnScale: (resolution) => resolution ? 1/Math.pow(resolution, 1/5) : 1,
                    },
                },
            }
        },
        config: {

        },
    },
};

export default state;